import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useTheme, alpha } from '@mui/material'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import defaultTexts from '../../../texts/texts'
import constants from '../../../config/constants'
import { request } from '../../../_network/request'
import { serviceConfigsURLs, billingAccountServicesURLs } from '../../../_network/apiUrls'
import CustomBackdrop from '../../_common/CustomBackdrop'

const RegionDelete = (props) => {
  const { regionName, services, billingServices, setFetchServices, handleRegionDeleteDialogClose } = props
  const theme = useTheme()

  const account_id = useSelector(state => state.profile.account_id)

  const [isLoading, setIsLoading] = useState(false)

  const deleteButtonStyle = {
    fontWeight: '500',
    color: 'white',
    background: theme.palette.greenSheen,
    fontSize: '18px',
    height: '40px',
    borderRadius: '20px',
    padding: '0px 30px',
    textTransform: 'capitalize',

    '&:hover': {
      background: alpha(theme.palette.greenSheen, 0.8),
    },
  }

  const deleteRequest = async () => {
    setIsLoading(true)

    const filteredServices = services.filter(item => item.config_params.region_name === regionName)

    for (let index = 0; index < filteredServices.length; index++) {
      const item = filteredServices[index]

      const url = constants.core_service_domain + '/' + serviceConfigsURLs.getClientServiceConfigs + '/' + item.id
      const request_data = { url, method: 'DELETE' }
      await request(request_data)
    }

    const filteredBillingServices = billingServices.filter(item => item.region_name === regionName)

    for (let index = 0; index < filteredBillingServices.length; index++) {
      const item = filteredBillingServices[index]

      const url = constants.billing_url + '/' + billingAccountServicesURLs.getAccountServices + '/' + item.id
      const request_data = { url, method: 'DELETE', headers: { 'customer-account-id': account_id } }
      await request(request_data)
    }

    setIsLoading(false)
    handleRegionDeleteDialogClose()
    setFetchServices(prev => prev + 1)
  }

  return (
    <>
      { isLoading && <CustomBackdrop open={isLoading} /> }

      <Box sx={{ marginBottom: '20px' }}>{defaultTexts.deleteRegionText.replace('###REGION###', regionName)}</Box>

      <Stack
        direction='row'
        justifyContent='flex-end'
      >
        <Button
          variant='contained'
          disableRipple
          disableElevation
          disabled={false}
          onClick={deleteRequest}
          sx={deleteButtonStyle}
        >
          {defaultTexts.delete}
        </Button>
      </Stack>
    </>
  )
}

export default RegionDelete